module.exports = __webpack_public_path__ + "1a8101023e1c44147cb7f6be6673ab2a.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/red_cured.png
 ** module id = 1075
 ** module chunks = 0
 **/